/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPromotions200ResponseItemsInner
 */
export interface GetPromotions200ResponseItemsInner {
    /**
     * 
     * @type {string}
     * @memberof GetPromotions200ResponseItemsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotions200ResponseItemsInner
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotions200ResponseItemsInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof GetPromotions200ResponseItemsInner
     */
    discountType: string;
    /**
     * 
     * @type {number}
     * @memberof GetPromotions200ResponseItemsInner
     */
    discountAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPromotions200ResponseItemsInner
     */
    enabled: boolean;
}

/**
 * Check if a given object implements the GetPromotions200ResponseItemsInner interface.
 */
export function instanceOfGetPromotions200ResponseItemsInner(value: object): value is GetPromotions200ResponseItemsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('enabled' in value) || value['enabled'] === undefined) return false;
    return true;
}

export function GetPromotions200ResponseItemsInnerFromJSON(json: any): GetPromotions200ResponseItemsInner {
    return GetPromotions200ResponseItemsInnerFromJSONTyped(json, false);
}

export function GetPromotions200ResponseItemsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPromotions200ResponseItemsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'discountType': json['discountType'],
        'discountAmount': json['discountAmount'] == null ? undefined : json['discountAmount'],
        'enabled': json['enabled'],
    };
}

export function GetPromotions200ResponseItemsInnerToJSON(json: any): GetPromotions200ResponseItemsInner {
    return GetPromotions200ResponseItemsInnerToJSONTyped(json, false);
}

export function GetPromotions200ResponseItemsInnerToJSONTyped(value?: GetPromotions200ResponseItemsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'discountType': value['discountType'],
        'discountAmount': value['discountAmount'],
        'enabled': value['enabled'],
    };
}

